import Table from "react-bootstrap/Table";
import { stateIndices } from "../ReactionPaths.js";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import Container from "react-bootstrap/Container";

const ReactionDataTable = ({ reactionData }) => {
  if (reactionData?.length > 0) {
    let steps = stateIndices[reactionData[0].reaction.reaction_type];
    let potentials = reactionData.map((reaction) => {
      return reaction.reaction.potential;
    });

    let borderStyle = { borderLeft: "2px solid #CCC" };
    let tableHead = [
      <th>State</th>,
      ...potentials.map((potential) => {
        return <th style={borderStyle}>{potential.toPrecision(3)} V</th>;
      }),
    ];

    let reactionRows = steps.map((step, step_i) => {
      let rowData = [
        <td>{step}</td>,
        ...potentials.map((potential, potential_i) => {
          let onclick = () => {
            window.open(
              (step_i === 0 || step_i === steps.length - 1
                ? "/catalysts/"
                : "/adsorbed_states/") +
                reactionData[potential_i].reaction.steps[step].systems[0],
            );
          };
          return (
            <td
              onClick={onclick}
              className="reaction-table-cell"
              style={borderStyle}
            >
              <div className="px-3 py-0">
                {" "}
                {reactionData[potential_i].reaction.steps[
                  step
                ].energies[0].toFixed(3)}
              </div>
            </td>
          );
        }),
      ];
      return <tr>{rowData}</tr>;
    });

    let ulRow = [
      <td>
        <MathJax inline={true}>{"\\(U_L\\)"}</MathJax>
      </td>,
      ...potentials.map((potential, potential_i) => {
        return (
          <td className="reaction-table-cell" style={borderStyle}>
            <div className="px-3 py-0">
              {reactionData[potential_i].reaction.limiting_potential.toFixed(3)}
            </div>
          </td>
        );
      }),
    ];

    let eSpanRow = [
      <td>
        <MathJax inline={true}>{"\\(\\Phi_{\\mathrm{max}}\\)"}</MathJax>
      </td>,
      ...potentials.map((potential, potential_i) => {
        return (
          <td className="reaction-table-cell" style={borderStyle}>
            <div className="px-3 py-0">
              {reactionData[potential_i].reaction.energetic_span.toFixed(3)}
            </div>
          </td>
        );
      }),
    ];

    return (
      <MathJaxContext>
        <Container>
          <Table hover>
            <tbody>
              <tr>{tableHead}</tr>
              {reactionRows}
              <tr>{ulRow}</tr>
              <tr>{eSpanRow}</tr>
            </tbody>
          </Table>
        </Container>
      </MathJaxContext>
    );
  }
};

export { ReactionDataTable };
